export default __webpack_public_path__ + "static/media/profile.57fc99ab.jpg";